import {
  DocumentCheckIcon,
  DocumentDuplicateIcon,
  MinusIcon,
  PencilSquareIcon,
  PlusIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Confirm from "../Confirm";
import { calculateAge } from "../Info/PersonInfo";
import { timeAgo } from "src/utils";
import Input from "../Inputs/Input";
import { Client } from "src/types";
import Modal from "../Modal";
import NotesEditor from "../NotesEditor";
import { updateData } from "src/services/client";
import Tasks from "../Tasks";
import Button from "../Inputs/Button";
import { AddTaskForm } from "../AddTask";

const ClientOverview = ({
  client,
  i,
  onDelete,
  onDuplicate,
  updateClient,
}: {
  client: Client;
  i: number;
  onDelete: any;
  onDuplicate: any;
  updateClient: any;
}) => {
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [duplicateOpen, setDuplicateOpen] = useState(false);
  const [newName, setNewName] = useState("");
  const [notesOpen, setNotesOpen] = useState(false);
  const [tasksOpen, setTasksOpen] = useState(false);
  const [addTaskOpen, setAddTaskOpen] = useState(false);

  const na = useNavigate();
  console.log("CLLC", client, client.tasks);
  const overdueTasksCount = client.tasks?.filter(
    (task) =>
      !task.completed && task.dueDate && new Date(task.dueDate) < new Date(),
  ).length;

  return (
    <>
      <tr
        className={`${i % 2 == 1 ? "bg-[#F9FAFB]" : "bg-white"} cursor-pointer border-y border-[#EAECF0] hover:bg-slate-100`}
        onClick={() => {
          na(`/client/${client.id}/map`);
        }}
      >
        <td className="px-2 py-3 text-sm">{client.title}</td>
        <td className="px-2 py-1 text-sm text-gray-500">
          {client.updatedAt && timeAgo(new Date(client.updatedAt))}
        </td>
        <td className="px-2 py-1 text-sm text-gray-500">
          {client.people
            .map(
              (person) =>
                `${person.name} (${calculateAge(new Date(person.birthday))})`,
            )
            .join(", ")}
        </td>
        <td
          className="px-2 py-1 "
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div className="flex gap-4 items-center">
            <div className="mr-[20px]">
              <Modal
                isOpen={tasksOpen}
                onClose={() => {
                  setTasksOpen(false);
                }}
              >
                <div>
                  <div
                    className="text-right mt-[0px] mb-[20px] text-xl font-bold cursor-pointer "
                    onClick={() => setTasksOpen(false)}
                  >
                    ✕
                  </div>
                  <Tasks
                    initialTasks={client.tasks || []}
                    client={client}
                    open={tasksOpen}
                    setExternal={(tasks) => {
                      updateClient({
                        ...client,
                        tasks,
                      });
                    }}
                  />
                </div>
              </Modal>
            </div>
            <div className="relative">
              <DocumentCheckIcon
                className="h-6 w-6"
                onClick={() => setTasksOpen(true)}
              />
              {overdueTasksCount > 0 && (
                <div
                  className="absolute -top-2 right-[-6px] bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold"
                  onClick={() => setTasksOpen(true)}
                >
                  {overdueTasksCount > 99 ? "99+" : overdueTasksCount}
                </div>
              )}
            </div>
            <PencilSquareIcon
              className=" w-6 cursor-pointer text-gray-700"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setNotesOpen(true);
              }}
            />
            <DocumentDuplicateIcon
              className="h-6 w-6 text-gray-700 cursor-pointer"
              onClick={(e) => {
                setDuplicateOpen(true);
                setNewName(client.title + " (2)");
                e.stopPropagation();
                e.preventDefault();
              }}
            />

            <TrashIcon
              className="h-5 w-6 text-red-500 cursor-pointer"
              onClick={(e) => {
                setDeleteOpen(true);
                e.stopPropagation();
                e.preventDefault();
              }}
            />
          </div>
          <Confirm
            isOpen={deleteOpen}
            onClose={() => setDeleteOpen(false)}
            onConfirm={() => {
              setDeleteOpen(false);
              onDelete(i);
            }}
          >
            <TrashIcon className="text-slate-400 w-10 m-auto mb-5" />
            <div className="mb-5">
              Are you sure you want to delete this client?
            </div>
          </Confirm>
          <Confirm
            isOpen={duplicateOpen}
            onClose={() => {
              setDuplicateOpen(false);
              setNewName("");
            }}
            onConfirm={() => {
              setDuplicateOpen(false);
              onDuplicate(client, newName);
            }}
          >
            <div className="mb-3 text-xl font-semibold">Duplicate client</div>
            <div className="mb-5">What should be the name of new client?</div>
            <Input
              width="w-full"
              value={newName}
              setValue={setNewName}
              label=""
            />
          </Confirm>
        </td>
      </tr>
      <Modal
        isOpen={notesOpen}
        onClose={() => {
          // updateData(client.id.toString(), { ...client, notes: content });
          setNotesOpen(false);
          setAddTaskOpen(false);
        }}
      >
        <div className="p-4 min-h-[500px]">
          <div className="flex justify-between mb-4">
            <h2 className="text-2xl font-semibold ">Client Notes</h2>
            <div className="">
              {!addTaskOpen && (
                <Button
                  type={addTaskOpen ? "secondary" : "primary"}
                  onClick={() => setAddTaskOpen(!addTaskOpen)}
                  className="flex items-center gap-2"
                >
                  {addTaskOpen ? (
                    <MinusIcon className="w-4 h-4" />
                  ) : (
                    <PlusIcon className="w-4 h-4" />
                  )}
                  {addTaskOpen ? "Cancel" : "Add Task"}
                </Button>
              )}
            </div>
          </div>

          <div className="flex gap-4 transition-all duration-300 ease-in-out">
            <div
              className={`transition-all duration-300 ease-in-out h-[490px] ${
                addTaskOpen ? "w-[800px] flex-shrink-0" : "w-[800px]"
              }`}
            >
              <NotesEditor
                initialContent={client.notes}
                setContent={(notes: string) => {
                  updateData(client.id.toString(), { ...client, notes });
                }}
              />
            </div>

            <div
              className={`transition-all duration-300 ease-in-out overflow-hidden ${
                addTaskOpen ? "w-[300px] opacity-100" : "w-0 opacity-0"
              }`}
            >
              {addTaskOpen && (
                <div className="bg-gray-50 p-4 rounded-lg h-fit">
                  <h3 className="text-lg font-semibold mb-4">Add New Task</h3>
                  <AddTaskForm
                    hideCancel
                    clients={[client] as any}
                    defaultClientId={client?.id as any}
                    onTaskCreated={(task) => {
                      updateClient({
                        ...client,
                        tasks: [...client.tasks, task],
                      });
                      setAddTaskOpen(false);
                    }}
                    onCancel={() => setAddTaskOpen(false)}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ClientOverview;
